module.exports = __webpack_public_path__ + "static/media/ai_video_poster.27bddeaa.png";